module.exports = __webpack_public_path__ + "img/CRT_Weapon-Sword-05.cd62e8e0.png";